import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Typography, Space } from 'antd';
import { ArrowRight } from 'lucide-react';
import { ROUTES } from '@/routes';
import { Logo } from '@/components';
import styles from './Home.module.scss';

const { Title, Paragraph } = Typography;

export const Home: React.FC = () => {
  return (
    <div className={styles.home}>
      <div className={styles.container}>
        <header className={styles.header}>
          <nav className={styles.nav}>
            <div className={styles.logo}>
              <Link to={ROUTES.HOME} aria-label="EvalTick">
                <Logo mode="light" />
              </Link>
            </div>
            <Space size="middle">
              <Link to={ROUTES.LOGIN}>
                <Button type="text">Login</Button>
              </Link>
              <Link to={ROUTES.REGISTER}>
                <Button type="primary">Get Started</Button>
              </Link>
            </Space>
          </nav>
        </header>

        <main className={styles.hero}>
          <div className={styles.heroContent}>
            <Title level={1} className={styles.title}>
              Welcome to <Logo mode="light" />
            </Title>
            <Paragraph className={styles.subtitle}>
              Your application tagline goes here. Describe what makes
              your product valuable and unique.
            </Paragraph>
            <Space size="large" className={styles.cta}>
              <Link to={ROUTES.DASHBOARD}>
                <Button type="primary" size="large" icon={<ArrowRight style={{ width: '1em', height: '1em' }} />}>
                  Go to Dashboard
                </Button>
              </Link>
              <Button size="large">Learn More</Button>
            </Space>
          </div>
        </main>

        <footer className={styles.footer}>
          <Paragraph type="secondary">
            &copy; {new Date().getFullYear()} <Logo mode="light" />. All rights reserved.
          </Paragraph>
        </footer>
      </div>
    </div>
  );
};

export default Home;
